<script setup>
import { computed } from 'vue';
import { useLocalizedTime } from 'shared/composables/useLocalizedTime';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt } = useMessageContext();

const { dateTime } = useLocalizedTime();
const readableTime = computed(() => dateTime(createdAt.value));
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="content" :title="content" />
  </BaseBubble>
</template>
